import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import PageAddDepartment from '../../pages/Departments/Add';

const ModalAddDepartment = props => {
  const { handleModalClose, showModal } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageAddDepartment handleModalClose={handleModalClose} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalAddDepartment.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool
};

export default ModalAddDepartment;
